// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unauthed-home-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: rgba(210, 233, 248, 0.041);
  /* max-width: 90% ; */
  border-radius: 5px;
  padding: 10px;
  height: 100%;
  width: 100%;
  background: linear-gradient(20deg, #099ab362, #ba5a4764);
  background-size: 600% 600%;
  animation: AnimationName 10s ease infinite;
}
@keyframes AnimationName {
  0%{background-position:0% 50%}
  50%{background-position:100% 50%}
  100%{background-position:0% 50%}
}


.unauthed-home-container > img {
  width: 175px;
  height: 175px;
}

.unauthed-home-container-title {
  font-size: xx-large;
  font-weight: bold;
}

.unauthed-home-container-subtitle {
  margin-top: 20px;
  font-size: large;
  /* width: 80%; */
}

@media (max-width: 400px) {
  .unauthed-home-container {
    /* justify-content: flex-start; */
    margin-top: 30px;
    /* background-color: rgba(105, 105, 105, 0.096); */
    border-color: rgba(30, 40, 49, 0.158);
    border-style: solid;
    border-width: 1px;
  }

  .unauthed-home-container > img {
    width: 100px;
    height: 100px;
  }
  .unauthed-home-container-subtitle {
    font-size: small;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Unauthed/Home/UnauthedHome.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;EAC5C,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,wDAAwD;EACxD,0BAA0B;EAG1B,0CAA0C;AAC5C;AAaA;EACE,GAAG,0BAA0B;EAC7B,IAAI,4BAA4B;EAChC,KAAK,0BAA0B;AACjC;;;AAGA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,iCAAiC;IACjC,gBAAgB;IAChB,kDAAkD;IAClD,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".unauthed-home-container {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  background-color: rgba(210, 233, 248, 0.041);\n  /* max-width: 90% ; */\n  border-radius: 5px;\n  padding: 10px;\n  height: 100%;\n  width: 100%;\n  background: linear-gradient(20deg, #099ab362, #ba5a4764);\n  background-size: 600% 600%;\n  -webkit-animation: AnimationName 10s ease infinite;\n  -moz-animation: AnimationName 10s ease infinite;\n  animation: AnimationName 10s ease infinite;\n}\n\n\n@-webkit-keyframes AnimationName {\n  0%{background-position:0% 50%}\n  50%{background-position:100% 50%}\n  100%{background-position:0% 50%}\n}\n@-moz-keyframes AnimationName {\n  0%{background-position:0% 50%}\n  50%{background-position:100% 50%}\n  100%{background-position:0% 50%}\n}\n@keyframes AnimationName {\n  0%{background-position:0% 50%}\n  50%{background-position:100% 50%}\n  100%{background-position:0% 50%}\n}\n\n\n.unauthed-home-container > img {\n  width: 175px;\n  height: 175px;\n}\n\n.unauthed-home-container-title {\n  font-size: xx-large;\n  font-weight: bold;\n}\n\n.unauthed-home-container-subtitle {\n  margin-top: 20px;\n  font-size: large;\n  /* width: 80%; */\n}\n\n@media (max-width: 400px) {\n  .unauthed-home-container {\n    /* justify-content: flex-start; */\n    margin-top: 30px;\n    /* background-color: rgba(105, 105, 105, 0.096); */\n    border-color: rgba(30, 40, 49, 0.158);\n    border-style: solid;\n    border-width: 1px;\n  }\n\n  .unauthed-home-container > img {\n    width: 100px;\n    height: 100px;\n  }\n  .unauthed-home-container-subtitle {\n    font-size: small;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
